package repdb

import kotlin.Long

public actual abstract class RepWithAttachmentDao {
  public actual abstract fun insert(entityWithAttachment: RepEntityWithAttachment): Long

  public actual abstract suspend fun insertAsync(entityWithAttachment: RepEntityWithAttachment):
      Long

  public actual abstract fun replace(entityWithAttachment: RepEntityWithAttachment)

  public actual abstract fun findByUid(uid: Long): RepEntityWithAttachment?

  public actual abstract fun update(entity: RepEntityWithAttachment)
}
